export const textCodes = {
    mediaText: {
        code: "${merchantId}_tmpl_text_13",
        text: 'မြန်မာနိုင်ငံမှာ fast fashion ရေစီးကြောင်းခေတ်စားနေတာကြာပါပြီ။ အဝတ်အစားတွေကိုအချိန်တိုအတွင်းမှာအမြောက်အများထုတ်လုပ်မယ်။ ပြီးရင်ဈေးသက်သက်သာသာနဲ့ဈေးကွက်တင်မယ်။ ဈေးနှုန်းချိုသာတယ်ဆိုတာကောင်းပေမယ့် တဘက်မှာလည်းအဝတ်အထည်ကဏ္ဍကကမ္ဘာကြီးအပေါ်ဆိုးကျိုးတွေပေးနိုင်တာကိုတော့မမေ့သင့်ပါဘူး။'
    },
}

export const titleCodes = {
    mediaTitle: {
        code: "${merchantId}_tmpl_title_11",
        title: 'WILLOW CLOTHING – ရိုးရိုးလေးလည်းလှပါတယ်'
    },

    story: {
        code: "${merchantId}_tmpl_title_2",
        title: 'our story'
    },
}

